module.exports = __webpack_public_path__ + "static/media/deleteIcon.05cb3850.svg";